var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s_chat_middle_emoji"},_vm._l((_vm.emojis),function(item,index){return _c('chat-middle-emoji-face',{key:index,attrs:{"text":item},on:{"emitEmojiClick":_vm.emitEmojiClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }